// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3OkCn","tab":"ProcedureTabs_tab__2Jqgm"};